import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { PERSONAS } from "../lib/personas";
import Avatar from "../components/Avatar";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Eye } from "lucide-react";

export default function Personas() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["personas"],
    queryFn: async () => (await api.get("/personas")).data.data,
  });

  const byKey = {};
  (data || []).forEach((u) => { if (u.persona) byKey[u.persona] = u; });

  return (
    <div className="p-8 max-w-[1400px] mx-auto" data-testid="personas-page">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-terracotta-light text-terracotta text-[12px] font-medium mb-3">
          Scénarios de démo IAM
        </div>
        <h1 className="font-heading text-[48px] font-semibold text-warm-dark tracking-tight leading-tight">Personas démo</h1>
        <p className="text-[16px] text-warm-dark/70 mt-2 max-w-2xl">
          Cinq collaborateurs protégés qui racontent toute l'histoire de votre organisation RH —
          à utiliser pour démontrer les flows NIM/Usercube : onboarding, mobilité, offboarding, extension CDD, missions externes.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
        {PERSONAS.map((p) => {
          const live = byKey[p.key];
          return (
            <Card key={p.key} className="p-6 bg-off-white border-sand shadow-soft rounded-xl" data-testid={`persona-card-${p.key}`}>
              <div className="flex items-start gap-4">
                <Avatar name={p.display_name} seed={p.key} size="lg" />
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-[20px] font-semibold text-warm-dark leading-tight">{p.display_name}</div>
                  <div className="text-[13px] text-warm-dark/70 mt-0.5">{p.role}</div>
                  <span className="inline-flex mt-2 items-center px-2 py-0.5 rounded-full bg-terracotta-light text-terracotta text-[11px] font-medium">
                    Persona démo
                  </span>
                </div>
              </div>
              <div className="mt-5 space-y-2 text-[13px]">
                <Row label="Site" value={p.site} />
                <Row label="Contrat" value={p.contract} />
                <Row label="Région" value={p.region} />
                <Row label="Email" value={p.email} mono />
              </div>
              <div className="mt-4 text-[12px] text-warm-dark/60 italic border-t border-sand pt-3">
                {p.summary}
              </div>
              <div className="mt-5 flex justify-end">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => live && navigate(`/users?q=${encodeURIComponent(p.email)}`)}
                  disabled={!live}
                  className="border-sand text-warm-dark hover:bg-terracotta-light/40"
                  data-testid={`persona-view-${p.key}`}
                >
                  <Eye size={13} strokeWidth={1.5} className="mr-1.5" />
                  Voir dans la liste
                </Button>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <span className="text-warm-dark/60 text-[12px] uppercase tracking-wider">{label}</span>
      <span className={`text-warm-dark ${mono ? "font-mono text-[12px]" : ""} text-right truncate`}>{value}</span>
    </div>
  );
}
